<!-- =========================================================================================
    File Name: TodoEdit.vue
    Description: Edit todo component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-prompt
    :active.sync="activePrompt"
    :is-valid="validateForm"
    @accept="submitTodo"
    @cancel="removeTodo"
    @close="init"
    accept-text="Submit"
    button-cancel="border"
    cancel-text="Remove"
    title="Edit Task">
    <div>
      <form>
        <div class="vx-row">
          <div class="vx-col w-1/6 self-center">
            <vs-checkbox class="w-8" v-model="taskLocal.isCompleted"></vs-checkbox>
          </div>

          <div class="vx-col ml-auto flex">
            <feather-icon
              :svgClasses="[{'text-success stroke-current': taskLocal.isImportant}, 'w-5', 'h-5 mr-4']"
              @click.prevent="taskLocal.isImportant = !taskLocal.isImportant"
              class="cursor-pointer"
              icon="InfoIcon"/>

            <feather-icon
              :svgClasses="[{'text-warning stroke-current': taskLocal.isStarred}, 'w-5', 'h-5 mr-4']"
              @click.prevent="taskLocal.isStarred = !taskLocal.isStarred"
              class="cursor-pointer"
              icon="StarIcon"/>

            <vs-dropdown class="cursor-pointer flex" vs-custom-content>

              <feather-icon icon="TagIcon" svgClasses="h-5 w-5"/>

              <vs-dropdown-menu style="z-index: 200001">
                <vs-dropdown-item :key="index" @click.stop v-for="(tag, index) in taskTags">
                  <vs-checkbox :vs-value="tag.value" v-model="taskLocal.tags">{{ tag.text }}</vs-checkbox>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-input class="w-full mb-4 mt-5" name="title" placeholder="Title" v-model="taskLocal.title" v-validate="'required'"/>
            <vs-textarea label="Add description" rows="5" v-model="taskLocal.desc"/>
          </div>
        </div>

      </form>
    </div>
  </vs-prompt>
</template>

<script>
  export default {
    props:    {
      displayPrompt: {
        type:     Boolean,
        required: true
      },
      taskId:        {
        type:     Number,
        required: true
      }
    },
    data ()
    {
      return {
        taskLocal: Object.assign({}, this.$store.getters['todo/getTask'](this.taskId))
      }
    },
    computed: {
      activePrompt: {
        get ()
        {
          return this.displayPrompt
        },
        set (value)
        {
          this.$emit('hideDisplayPrompt', value)
        }
      },
      taskTags ()
      {
        return this.$store.state.todo.taskTags
      },
      validateForm ()
      {
        return !this.errors.any() && this.taskLocal.title !== ''
      }
    },
    methods:  {
      removeTodo ()
      {
        this.$store.dispatch('todo/updateTask', Object.assign({}, this.taskLocal, {isTrashed: true}))
          .then(() => {
            // Fetch Tasks
            this.$store.dispatch('todo/fetchTasks', {filter: this.$route.params.filter})
          })
          .catch((error) => { console.error(error) })
      },
      init ()
      {
        this.taskLocal = Object.assign({}, this.$store.getters['todo/getTask'](this.taskId))
      },
      submitTodo ()
      {
        this.$store.dispatch('todo/updateTask', this.taskLocal)
      }
    }
  }
</script>
